import {chain}  from "../../utils/fs";
import {values} from "../../utils/objects";

export const itemCreditLines = ({item, cart}) => chain(
    values(item.itemTotals),
    (total) => [
        chain(
            total.find((t) => t.type === "promoCode"),
            (t) => t && ({
                label: "Promo Code",
                value: -t.amount,
            }),
        ),
        ...total.filter((t) => !["subTotal", "shippingCharge", "salesTax", "rdf", "importTax", "vatTax", "handlingFee", "promoCode"].includes(t.type)).map((t) => ({
            label: t.name,
            value: t.amount,
        })),

        ...[
            {
                getLabel: (c) => "Copay: " + c.copayAddress.streetAddress,
                attr: "copays",
            },
            {
                getLabel: (v) => v.name ? "Voucher " + v.name : "Voucher",
                attr: "vouchers",
            },
            {
                label: "Ad Budget",
                attr: "adBudgets",
            },
            {
                label: "Store Credit",
                attr: "storeCredits",
            },
        ].map(({label, getLabel, attr}) => {
            const credit = cart.appliedCredits?.[attr]?.find((credit) => credit.itemId == item.itemId);
            return credit && {
                label: getLabel? getLabel(credit) : label,
                value: -credit.amount,
            };
        }),
    ].filter(v=>v),
);
